import { useTranslation } from 'next-i18next/pages';
import { useEffect, useMemo, useState } from 'react';

import { getCurrentLang } from '@/lib/i18n/getCurrentLang';
import { loadClientNamespaces } from '@/lib/i18n/loadClientNamespaces';
import rollbarClient from '@/lib/rollbar/rollbarClient';
import type { SupportedLanguage } from '@/utils/globalTypes';

import type Rollbar from 'rollbar';

export function usePageTranslations(namespaces: string[] = []) {
  const { i18n } = useTranslation();
  const [ready, setReady] = useState(false);

  const namespacesKey = useMemo(() => namespaces.slice().sort().join('|'), [namespaces]);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      try {
        const lang = getCurrentLang() as SupportedLanguage;
        await loadClientNamespaces(i18n, lang, namespaces);
      } catch (error: unknown) {
        rollbarClient.error('Client page translations failed to load', error as Rollbar.LogArgument, {
          namespaces,
        });
      } finally {
        if (!cancelled) {
          setReady(true);
        }
      }
    };

    setReady(false);
    void run();

    return () => {
      cancelled = true;
    };
  }, [i18n, namespacesKey, namespaces]);

  return ready;
}
